import { h } from 'preact';
export const FileText = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
        h("polyline", { points: "14 2 14 8 20 8" }),
        h("line", { x1: "16", y1: "13", x2: "8", y2: "13" }),
        h("line", { x1: "16", y1: "17", x2: "8", y2: "17" }),
        h("polyline", { points: "10 9 9 9 8 9" })));
};
//# sourceMappingURL=file-text.js.map